export enum Experiment {
  EnableSectionsTabInMobileAS = 'specs.membersAboutOOI.enableSectionsMobileAS',
  EnableOOIInEditor = 'specs.membersArea.framelessEditorProfilePage',
  RenderSEOTags = 'specs.membersAboutOOI.RenderSEOTags',
  AboutPublishValidation = 'specs.about.MembersAboutSpecs$ValidateLinksInAboutContent',
  RateFromAppSettings = 'specs.membersArea.rateFromAppSettings',
}
